import { useRef, useState, useCallback } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const RECAPTCHA_SITE_KEY = '6Lclx6UZAAAAAAJPzjIzuni5BEHrRGUzU9Rz87HS';

export const getSiteKey = (): string => {
  return RECAPTCHA_SITE_KEY;
};

interface UseRecaptchaV2Return {
  recaptchaRef: React.RefObject<ReCAPTCHA>;
  recaptchaResponse: string;
  setRecaptchaResponse: (value: string) => void;
  resetRecaptcha: () => void;
  siteKey: string;
  isRecaptchaValid: boolean;
}

export const useRecaptcha = (): UseRecaptchaV2Return => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [recaptchaResponse, setRecaptchaResponse] = useState<string>('');
  const siteKey = getSiteKey();

  const resetRecaptcha = useCallback(() => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
    setRecaptchaResponse('');
  }, []);

  const isRecaptchaValid = recaptchaResponse.length > 0;

  return {
    recaptchaRef,
    recaptchaResponse,
    setRecaptchaResponse,
    resetRecaptcha,
    siteKey,
    isRecaptchaValid,
  };
};

export const getRecaptchaSiteKey = (): string => getSiteKey();

export default useRecaptcha;
